// extracted by mini-css-extract-plugin
export default {"rating":"tN-z","numberOfStars":"uN-z","count":"vN-z","barGraphSpacing":"wN-z","barGraph":"xN-z"};